export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',

      // Border colors
      backgroundBorder: '#49505733',

      // Focus/hover colors - when alpha is applied, will give us the hover effect
      focus: '#495057', // This will become #49505726 with 0.1 alpha
    },
    dark: {
      // Custom dark mode colors matching our theme
      background: '#1A1A1A', // Use our custom dark background
      backgroundPrimary: '#1A1A1A',
      backgroundSecondary: '#2D2D2D',
      backgroundTertiary: '#404040',
      backgroundCardPrimary: '#2D2D2D',
      backgroundCardSecondary: '#404040',

      // Primary colors (matching our theme)
      primary: '#DDB967',
      secondary: '#6C757D',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',

      // Text colors
      textPrimary: '#FFFFFF',
      textInverted: '#212529',

      // Border colors
      backgroundBorder: '#4950574D',

      // Focus/hover colors - when alpha is applied, will give us the hover effect
      focus: '#495057', // This will become #49505726 with 0.1 alpha

      // Element backgrounds
      backgroundElement: '#404040',
    },
  },
}
